import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD, HREF_FIELD } from "../commonFields";

export const linkBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Link",
  noWrap: true,
  image: "https://icon-library.com/images/link-icon-svg/link-icon-svg-29.jpg",
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  inputs: [
    {
      name: "text",
      type: "text",
      localized: true,
      required: true,
    },
    HREF_FIELD,
    DLD_FIELD,
    DLT_FIELD,
    {
      name: "hoverStyle",
      type: "uiStyle",
      localized: false,
      defaultValue: {
        textDecoration: "underline",
      },
    },
    {
      name: "activeStyle",
      type: "uiStyle",
      localized: false,
      defaultValue: {},
    },
    {
      name: "focusStyle",
      type: "uiStyle",
      localized: false,
      defaultValue: {},
    },
    {
      name: "visitedStyle",
      type: "uiStyle",
      localized: false,
      defaultValue: {},
    },
  ],
};
